module.exports = __webpack_public_path__ + "img/cs-1.2c26c20d.png";